/*************************************************/
/* HEADER                                        */
/*************************************************/

export function header($body) {
    let $header,
        $menuNavParent,
        megaMenuOpenClass;

    const init = function () {
        $header = $(".header"),
            $menuNavParent = $(".menu-nav__item--w-dropdown"),
            megaMenuOpenClass = "menu-nav__item--mega-menu-open";

        // Sticky header
        setStickyHeader();
        $(window).scroll(function () {
            setStickyHeader();
        });

        //Mega menu
        $menuNavParent.click(function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (!$(this).hasClass(megaMenuOpenClass)) {
                closeMegaMenu();
                $(this).addClass(megaMenuOpenClass);
            } else {
                $(this).removeClass(megaMenuOpenClass);
            }
        });

        $menuNavParent.find(".mega-menu-overlay").click(function (e) {
            e.stopPropagation();
        });

        $body.click(function () {
            closeMegaMenu();
        });
    };

    init();

    function closeMegaMenu() {
        $menuNavParent.removeClass(megaMenuOpenClass);
    }

    function setStickyHeader() {
        if ($(window).scrollTop() > $header.height() / 2) {
            $body.addClass("header-sticky");
        } else {
            $body.removeClass("header-sticky");
        }
    }
}

